import { ModulesState } from './modules.state';

import * as module from './modules.actions';

export const initialState: ModulesState = {
	route:[]
};

export function modulesReducer(state = initialState, action: module.Actions): ModulesState {

	switch (action.type) {

    case module.GET_ROUTES:
		return {
			...state,
        	route:action.payload.route,
		};

	case module.SET_ROUTES:
		return {
			...state,
        	route:action.payload.route,
		};
	case module.DELETE_ROUTES:
		return {
			...state,
			route: action.payload.route,
		}
	
		default:
		return state;
	}


}
